import React, { useState } from "react";

import UserContext from "../../../../context/Context";

let gstDetails = [];
export const PurchaseGstCalculation = (Party, product, Context, Charges) => {
  console.log('part', Party)
  let IgstTotal = 0;
  let CgstTotal = 0;
  let SgstTotal = 0;
  let Amount = 0;
  let GrandTotal = 0;
  let RoundOff = 0;
  let Discount = 0;
  let DiscountPercentage = 0;
  let OtherGSTCharges = 0;
  if (!!Party?.category?.discount) {
    DiscountPercentage = (100 + Party?.category?.discount) / 100;
    // DiscountPercentage = 1;
  } else {
    DiscountPercentage = (100 + Party?.category?.discount) / 100;

    // DiscountPercentage = 1;
  }
  function customRound(num) {
    let decimalPart = num - Math.floor(num);
    if (decimalPart > 0.49) {
      return Math.ceil(num);
    } else {
      return Math.floor(num);
    }
  }
  let IgstTaxType = false;

  let SuperGst = Context?.CompanyDetails?.gstNo?.slice(0, 2);
  let userdata = JSON.parse(localStorage.getItem("userData"));
  let findParty = userdata?.rolename?.roleName == "Customer";

  let partyGst;
  if (findParty) {
    partyGst = userdata?.gstNumber?.slice(0, 2);
  } else {
    if (Party?.registrationType == "UnRegister") {
      partyGst = SuperGst;
    } else {
      partyGst = Party?.gstNumber?.slice(0, 2);
    }
  }
  product?.forEach((ele) => {
    if (typeof ele?.gstPercentage == "number") {
      return ele;
    } else {
      if (ele?.gstPercentage?.includes("+")) {
        ele["gstPercentage"] = Number(ele?.gstPercentage?.split("+")[0] * 2);
        return Number(ele);
      } else {
        // return Number(ele);
        ele["gstPercentage"] = ele?.gstPercentage;
      }
    }
  });

  let maxGst = product.reduce(function (prev, current) {
    return prev && Number(prev?.gstPercentage) > Number(current?.gstPercentage)
      ? prev
      : current;
  });
  maxGst["gstPercentage"] = Number(maxGst?.gstPercentage);

  if (Charges) {
    OtherGSTCharges = Number(
      ((Charges * maxGst?.gstPercentage) / 100).toFixed(2)
    );
  }
  if (SuperGst == partyGst) {
    IgstTaxType = false;
    gstDetails = product?.map((ele, i) => {
      let GstRate = Number(ele?.productData?.GSTRate) / 2;
      let wholeGst = Number(ele?.productData?.GSTRate);
      console.log('price', ele?.price)
      let costPrice = Number(
        (
          ele?.price
        )
      );
      let Cp_without_Discount = Number(
        (
          ele?.price /
          ((100 + Number(ele?.productData?.GSTRate)) / 100)
        ).toFixed(2)
      );
      let sellingPrice = costPrice * ele?.qty;
      let total = Number(((sellingPrice * (100 + wholeGst)) / 100).toFixed(2));
      console.log('taxa', Number(
        ((costPrice * ele?.qty)).toFixed(2)
      ))
      return {
        gstPercentage: `${GstRate}+${GstRate}`,
        sgstRate: Number(((costPrice * Number(GstRate)) / 100).toFixed(2)),
        cgstRate: Number(((costPrice * Number(GstRate)) / 100).toFixed(2)),
        igstRate: 0,
        totalRate: Number(((costPrice * wholeGst) / 100).toFixed(2)),
        costPrice: costPrice,
        hsn: ele?.productData?.HSN_Code,
        withoutTaxablePrice: `${
          costPrice * ele?.qty !== undefined ? Number(costPrice * ele?.qty) : 0
        }`,
        taxable: Number((costPrice * ele?.qty).toFixed(2)),

        discountPercentage:
          Party?.category?.discount && Party?.category?.discount
            ? Party?.category?.discount
            : 0,
        withDiscountAmount: Number(
          ((costPrice * ele?.qty * (100 + wholeGst)) / 100).toFixed(2)
        ),
        taxableValue: Number(
          ((costPrice * ele?.qty * (100 + wholeGst)) / 100).toFixed(2)
        ),
        taxableAmount: Number(
          ((costPrice * ele?.qty)).toFixed(2)
        ),
      
        unitPriceAfterDiscount: Number(costPrice.toFixed(2)),
        withoutDiscountAmount: Number(
          ((Cp_without_Discount * ele?.qty * (100 + wholeGst)) / 100).toFixed(2)
        ),
        centralTax: [
          {
            rate: GstRate,
            amount: Number(((costPrice * ele?.qty * GstRate) / 100).toFixed(2)),
          },
        ],
        stateTax: [
          {
            rate: GstRate,
            amount: Number(((costPrice * ele?.qty * GstRate) / 100).toFixed(2)),
          },
        ],
        igstTax: [],
        grandTotal: Number(total),
      };
    });
  } else {
    gstDetails = product?.map((ele, i) => {
   
      let GstRate = Number(ele?.productData?.GSTRate) / 2;
      let wholeGst = Number(ele?.productData?.GSTRate);
      console.log('price', ele?.price)
      let costPrice = Number(
        (
          ele?.price
        )
      );
      console.log('tc', costPrice)
      let Cp_without_Discount = Number(
        (
          ele?.price /
          ((100 + Number(ele?.productData?.GSTRate)) / 100)
        ).toFixed(2)
      );
      let sellingPrice = costPrice * ele?.qty;

      IgstTaxType = true;

      let total = Number(
        ((costPrice * ele?.qty * (100 + wholeGst)) / 100).toFixed(2)
      );

      return {
        unitPriceAfterDiscount: Number(costPrice?.toFixed(2)),
        gstPercentage: Number(ele?.productData?.GSTRate),
        sgstRate: 0,
        cgstRate: 0,
        igstRate: Number(((costPrice * ele?.qty * wholeGst) / 100).toFixed(2)),
        costPrice: costPrice,
        grandTotal: Number(total),
        taxableAmount: Number(
          ((costPrice * ele?.qty)).toFixed(2)
        ),
        hsn: ele?.productData?.HSN_Code,

        taxable: Number((costPrice * ele?.qty).toFixed(2)),
        withoutTaxablePrice: `${
          costPrice * ele?.qty !== undefined ? Number(costPrice * ele?.qty) : 0
        }`,

        discountPercentage: Party?.category?.discount,
        withDiscountAmount: Number(
          ((costPrice * ele?.qty * (100 + wholeGst)) / 100).toFixed(2)
        ),
        withoutDiscountAmount: Number(
          ((Cp_without_Discount * ele?.qty * (100 + wholeGst)) / 100).toFixed(2)
        ),

        totalTaxAmount: Number(
          ((costPrice * ele?.qty * (100 + wholeGst)) / 100).toFixed(2)
        ),
        centralTax: [],
        stateTax: [],
        igstTax: [
          {
            rate: wholeGst,
            amount: Number(
              ((costPrice * ele?.qty * wholeGst) / 100).toFixed(2)
            ),
          },
        ],
      };
    });
  }
  let T = gstDetails?.map((ele, i) => {
    return ele?.taxable;
  });
  Amount = T.reduce((a, b) => a + b, 0);

  if (IgstTaxType) {
    let x = gstDetails?.map((ele, i) => {
      return ele?.igstTax[0]?.amount;
    });
    IgstTotal = x.reduce((a, b) => a + b, 0);
  } else {
    let C = gstDetails?.map((ele, i) => {
      return ele?.centralTax[0]?.amount;
    });
    CgstTotal = C.reduce((a, b) => a + b, 0);
    let S = gstDetails?.map((ele, i) => {
      return ele?.stateTax[0]?.amount;
    });
    SgstTotal = S.reduce((a, b) => a + b, 0);
  }
  GrandTotal = Number(
    (
      Amount +
      SgstTotal +
      CgstTotal +
      IgstTotal +
      Charges +
      OtherGSTCharges
    )?.toFixed(2)
  );
  RoundOff = customRound(GrandTotal);
  let Tax = {
    maxGst: maxGst?.gstPercentage,
    OtherGSTCharges: OtherGSTCharges,
    TotalOtherCharges: Number((Charges + OtherGSTCharges).toFixed(2)),
    Charges: Charges,
    IgstTaxType: IgstTaxType,
    // RoundOff: RoundOff - GrandTotal,
    RoundOff:
      RoundOff > GrandTotal
        ? Number((RoundOff - GrandTotal).toFixed(2))
        : Number((RoundOff - GrandTotal).toFixed(2)),
    GrandTotal: Number(RoundOff?.toFixed(2)),
    // RoundOff: Number(RoundOff.toFixed(2)),
    // GrandTotal: Number(GrandTotal?.toFixed(2)),
    Amount: Number(Amount?.toFixed(2)),
    IgstTotal: IgstTaxType
      ? Number((IgstTotal + OtherGSTCharges)?.toFixed(2))
      : Number(IgstTotal.toFixed(2)),
    CgstTotal: IgstTaxType
      ? Number(CgstTotal.toFixed(2))
      : Number((CgstTotal + OtherGSTCharges / 2)?.toFixed(2)),
    SgstTotal: IgstTaxType
      ? Number(SgstTotal.toFixed(2))
      : Number((SgstTotal + OtherGSTCharges / 2)?.toFixed(2)),
  };
  return { gstDetails, Tax };
};
